import React from 'react';
import { Textbox } from "components/Textbox/Textbox";

interface ProgressBarSettingsProps {
    object: any;
    resetForm: boolean;
}

export const ProgressBarSettings: React.FC<ProgressBarSettingsProps> = ({ object, resetForm }) => {
    return (
        <div className="col-12">
            <div className="d-flex align-items-end w-100 h-100">
                <Textbox
                    resetForm={resetForm}
                    textboxType="number"
                    textboxName="defaultValue"
                    labelText="defaultValue"
                    defaultValue={object?.defaultValue === '' || !object?.defaultValue ? 0 : object?.defaultValue}
                    min={0}
                    max={100}
                />
            </div>
        </div>
    );
}; 